const clickedPos = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

// eslint-disable-next-line import/prefer-default-export
export { clickedPos };
